@import '../../sass/helpers';

som-dialog {
  som-modal {
    .modal {
      @media (max-width: 767.98px) {
        width: 96% !important;
        //height: auto !important;
        min-height: auto !important;
        max-height: 70vh !important;
      }
    }

    @media (max-width: 767.98px) {
      &[open] {
        background-color: rgba($black, 0.7);
      }
    }
  }
}
